import React, { createContext, useContext, useState, useEffect } from 'react';

const CurrencyContext = createContext();

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error('useCurrency must be used within a CurrencyProvider');
  }
  return context;
};

// Supported currencies with their symbols and display names
export const SUPPORTED_CURRENCIES = {
  USD: { symbol: '$', name: 'US Dollar', code: 'USD' },
  EUR: { symbol: '€', name: 'Euro', code: 'EUR' },
  GBP: { symbol: '£', name: 'British Pound', code: 'GBP' },
  CAD: { symbol: 'C$', name: 'Canadian Dollar', code: 'CAD' },
  AUD: { symbol: 'A$', name: 'Australian Dollar', code: 'AUD' },
  JPY: { symbol: '¥', name: 'Japanese Yen', code: 'JPY' },
  CHF: { symbol: 'CHF', name: 'Swiss Franc', code: 'CHF' },
  SEK: { symbol: 'kr', name: 'Swedish Krona', code: 'SEK' },
  NOK: { symbol: 'kr', name: 'Norwegian Krone', code: 'NOK' },
  DKK: { symbol: 'kr', name: 'Danish Krone', code: 'DKK' }
};

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState(() => {
    // Initialize from localStorage or default to EUR
    return localStorage.getItem('selected_currency') || 'EUR';
  });

  const [exchangeRates, setExchangeRates] = useState({});
  const [lastUpdated, setLastUpdated] = useState(null);

  useEffect(() => {
    // Save currency selection to localStorage whenever it changes
    localStorage.setItem('selected_currency', currency);
  }, [currency]);

  const changeCurrency = (newCurrency) => {
    if (SUPPORTED_CURRENCIES[newCurrency]) {
      setCurrency(newCurrency);
    }
  };

  const getCurrentCurrency = () => {
    return SUPPORTED_CURRENCIES[currency] || SUPPORTED_CURRENCIES.EUR;
  };

  const value = {
    currency,
    changeCurrency,
    getCurrentCurrency,
    supportedCurrencies: SUPPORTED_CURRENCIES,
    exchangeRates,
    setExchangeRates,
    lastUpdated,
    setLastUpdated
  };

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  );
};
